import React from 'react'
import { isNumber } from '@mote/helpers'
import styled, { css } from '@xstyled/styled-components'

export const Spinner = ({
  className = '',
  style = {},
  color = '#ac0ae8',
  radius: size = 40,
  duration = 900,
  strokeWidth = 3
}) => {
  const props = React.useMemo(
    () => ({
      root: {
        size
      },
      g: {
        strokeWidth
      },
      circle: {
        stroke: '#d1d1e0',
        strokeOpacity: 0.3
      },
      path: {
        stroke: color,
        strokeWidth
      }
    }),
    [color, size, strokeWidth]
  )

  return (
    <Root
      {...props.root}
      style={style}
      className={className}
      aria-hidden={true}
      tabIndex={-1}
    >
      <AnimatedSVG
        viewBox='0 0 42 42'
        animationDuration={duration}
        role='presentation'
        aria-hidden={true}
        focusable={false}
      >
        <g fill='none' transform='translate(3 3)' {...props.g}>
          <circle cx='18' cy='18' r='18' {...props.circle} />
          <path
            d='M36 18c0-9.94-8.06-18-18-18'
            strokeLinecap='round'
            strokeLinejoin='round'
            {...props.path}
          />
        </g>
      </AnimatedSVG>
    </Root>
  )
}

const Root = styled.div`
  display: block;
  flex-shrink: 0;

  ${({ size }) => css`
    width: ${isNumber(size) ? `${size}px` : size};
    height: ${isNumber(size) ? `${size}px` : size};
  `};
`

const AnimatedSVG = styled.svg`
  display: inline-block;
  width: 100%;
  height: 100%;
  animation: spinner;
  animation-duration: ${({ animationDuration }) => animationDuration}ms;
  animation-timing-function: linear;
  animation-iteration-count: infinite;

  @keyframes spinner {
    100% {
      transform: rotate(360deg);
    }
  }
`
